import StdListContext from 'contexts/StdListContext';
import React from 'react';

interface Props {
  children: React.ReactNode;
  enableScrolling?: boolean;
}

class StdListBody extends React.Component<Props> {
  render(): React.ReactNode {
    const { enableScrolling } = this.props;

    return (
      <StdListContext.Consumer>
        {({ id: listId }): React.ReactNode => (
          <div
            id={`${listId}-body`}
            className={`std-list-body grow-1 ${
              enableScrolling || enableScrolling === undefined ? 'oa' : ''
            }`}
            style={{ borderRadius: '0 0 8px 8px' }}
          >
            {this.props.children}
          </div>
        )}
      </StdListContext.Consumer>
    );
  }
}

export default StdListBody;
